import { render, staticRenderFns } from "./ProductDesc.vue?vue&type=template&id=d0990c0c&"
import script from "./ProductDesc.vue?vue&type=script&lang=ts&"
export * from "./ProductDesc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports